var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99943 15.1667C9.84036 15.1667 11.507 14.4205 12.7135 13.2141C13.9199 12.0076 14.6661 10.341 14.6661 8.50004C14.6661 6.65911 13.9199 4.99244 12.7135 3.78599C11.507 2.57957 9.84036 1.83337 7.99943 1.83337C6.1585 1.83337 4.49183 2.57957 3.28538 3.78599C2.07896 4.99244 1.33276 6.65911 1.33276 8.50004C1.33276 10.341 2.07896 12.0076 3.28538 13.2141C4.49183 14.4205 6.1585 15.1667 7.99943 15.1667Z",
    stroke: "#0056CC",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00057 4.16663C8.4608 4.16663 8.8339 4.53973 8.8339 4.99996C8.8339 5.46019 8.4608 5.83329 8.00057 5.83329C7.54034 5.83329 7.16724 5.46019 7.16724 4.99996C7.16724 4.53973 7.54034 4.16663 8.00057 4.16663Z",
    fill: "#0056CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16667 11.8333V7.16663H7.83333H7.5",
    stroke: "#0056CC",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.8334H9.33333",
    stroke: "#0056CC",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.84099d6ba76b55379b5096ba0b41fc84.svg";
export { ForwardRef as ReactComponent };